import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useReducer, useState } from "react";
import { Toast } from "@capacitor/toast";
import firstIcon from "../assets/userProfil/profileFirstIcon.png";
import secondIcon from "../assets/userProfil/profileSecondIcon.png";
import certificateIcon from "../assets/userProfil/certificatMock.png";
import checkWhiteIcon from "../assets/userProfil/checkWhiteIcon.png";
import errorWhiteIcon from "../assets/userProfil/errorWhieIcon.png";
import { useQuery } from "@tanstack/react-query";
import axios, { type AxiosError } from "axios";
import type { UserProfileData } from "../api/userProfil.types";
import { getProfileOptions } from "../api/queryOptions";
import { LoaderSpinner } from "../components/ui/LoaderSpinner";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { TrainingFile } from "../components/shared/TrainingFile";
import { Skeleton } from "@/components/ui/skeleton";
import { blobToBase64 } from "@/utils/blobToBase64";
import { getAccessToken } from "../utils/storage/authStorage";
import { useAuth } from "@/context/AuthContext";
import { ArrowIcon } from "@/components/icons/arrow";
import { Link } from "@tanstack/react-router";
// import { Browser } from "@capacitor/browser";
interface TogglerState {
	switcher: "MY_DATA" | "COURSES" | "CERTIFICATES";
}

type TogglerAction = {
	type: "TOGGLE_SWITCHER";
	payload: "MY_DATA" | "COURSES" | "CERTIFICATES";
};

function togglerReducer(
	state: TogglerState,
	action: TogglerAction
): TogglerState {
	switch (action.type) {
		case "TOGGLE_SWITCHER":
			return {
				...state,
				switcher: action.payload,
			};
		default:
			return state;
	}
}

// const handleCopy = async (text: string): void => {
// 	try {
// 		await navigator.clipboard.writeText(text);
// 		await Toast.show({
// 			text: "Skopiowano do schowka!",
// 			duration: "short",
// 			position: "bottom",
// 			style: "success",
// 		});
// 	} catch (error) {
// 		await Toast.show({
// 			text: "Błąd kopiowania",
// 			duration: "short",
// 			position: "bottom",
// 			style: "error",
// 		});
// 	}
// };

export const UserProfil = (): JSX.Element => {
	const [state, dispatch] = useReducer(togglerReducer, {
		switcher: "MY_DATA",
	});
	const [certificateLoader, setCertificateLoader] = useState<string | null>(
		null
	);

	const { data, isLoading } = useQuery<UserProfileData | undefined, AxiosError>(
		{
			...getProfileOptions,
		}
	);

	const { logout } = useAuth();

	const downloadCertificate = async (file: {
		name: string;
		download_link: string;
	}): Promise<void> => {
		setCertificateLoader(file.name);
		try {
			const token = await getAccessToken();
			const response = await axios.get<Blob>(file.download_link, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/pdf",
					Accept: "application/pdf",
				},
				responseType: "blob",
			});

			if (Capacitor.isNativePlatform()) {
				// Handle mobile download
				const base64Data = await blobToBase64(response.data);
				const fileName = file.name;

				await Filesystem.writeFile({
					path: `${fileName}.pdf`,
					data: base64Data,
					directory: Directory.Documents,
					recursive: true,
				});

				// Get the file URI
				const fileUri = await Filesystem.getUri({
					directory: Directory.Documents,
					path: `${fileName}.pdf`,
				});

				// Open the file
				await FileOpener.open({
					filePath: fileUri.uri,
					contentType: "application/pdf",
				});
			} else {
				// Handle web download
				const url = window.URL.createObjectURL(
					new Blob([response.data], { type: "application/pdf" })
				);
				const link = document.createElement("a");
				link.href = url;
				link.download = file.name;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}
			setCertificateLoader(null);
		} catch (error) {
			setCertificateLoader(null);
			console.error("Error downloading file:", error);
		}
	};

	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			{certificateLoader !== null && <LoadingOverlay opacity={10} />}
			<Tabs className="w-full pb-4" defaultValue="MY_DATA">
				<TabsList className="w-full">
					<TabsTrigger
						className="w-1/2 p-2"
						value="MY_DATA"
						onClick={() => {
							dispatch({ type: "TOGGLE_SWITCHER", payload: "MY_DATA" });
						}}
					>
						Moje Dane
					</TabsTrigger>
					{/* <TabsTrigger
						className="w-1/2 p-2"
						value="COURSES"
						onClick={() => {
							dispatch({ type: "TOGGLE_SWITCHER", payload: "COURSES" });
						}}
					>
						Materiały
					</TabsTrigger> */}
					<TabsTrigger
						className="w-1/2 p-2"
						value="CERTIFICATES"
						onClick={() => {
							dispatch({ type: "TOGGLE_SWITCHER", payload: "CERTIFICATES" });
						}}
					>
						Certyfikaty
					</TabsTrigger>
				</TabsList>
			</Tabs>
			{isLoading && (
				<div>
					<Skeleton className="h-[20px] w-full mb-5 rounded-xl" />
					<Skeleton className="h-[112px] w-full mb-5 rounded-xl" />
					<Skeleton className="h-7 w-full mb-2 rounded-xl" />
					<Skeleton className="h-7 w-full mb-5 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
					<Skeleton className="h-5 w-full mb-3 rounded-xl" />
				</div>
			)}
			{data && (
				<>
					{state.switcher === "MY_DATA" && (
						<div>
							<div
								className={`flex pl-[18px] py-[15px] rounded-[8px] my-6 ${data?.hasSubscription ? "bg-[#36B37E]" : "bg-[#FF726F]"}`}
							>
								<img
									alt="check icon"
									src={data?.hasSubscription ? checkWhiteIcon : errorWhiteIcon}
								/>
								<div className="text-[#FFFFFF] ml-[14px] flex">
									<p>Status subskrypcji: </p>
									<p className="font-bold ml-[2px]">{`${data?.hasSubscription ? " aktywna" : " nieaktywna"}`}</p>
								</div>
							</div>
							{/* KOD RABATOWY PROMOCYJNY */}
							{/* <div className="pl-[18px] py-[15px] rounded-[8px] mb-[15px] text-[#000810] bg-[#e6f7ff] border border-[#5b7a89]">
								<div className=" ml-[14px] flex">
									<p>Twój kod rabatowy: </p>
									<button
										className="font-bold ml-[2px] cursor-pointer"
										onClick={() => {
											handleCopy("MIKOLAJ");
										}}
									>
										MIKOLAJ
									</button>
								</div>
								<div className=" ml-[14px] text-[12px] text-[#638595]">
									<span>Wpisz go w koszyku podczas zakupów na stronie</span>
									<Button
										className="px-1"
										variant="link"
										size="sm"
										onClick={async () => {
											await Browser.open({ url: "https://akademialtca.pl" });
										}}
									>
										akademialtca.pl
									</Button>
								</div>
							</div> */}
							<div>
								<div className="flex items-center ">
									<img alt="user data icon" src={firstIcon} />
									<p className="font-semibold text-[17px] pl-3">Moje dane</p>
								</div>
								<div className="pt-[15px] pl-[41px]">
									<div className=" pb-4">
										<h3 className="text-[#637381] uppercase font-bold text-xs pb-2">
											Nazwa użytkownika
										</h3>
										<p className="text-[#19191B]">
											{data.user.first_name} {data.user.last_name}
										</p>
									</div>
									<div className="pb-4">
										<h3 className="text-[#637381] uppercase font-bold text-xs pb-2">
											Email
										</h3>
										<p className="text-[#19191B]">{data.user.email}</p>
									</div>
									<div className="pb-4">
										<h3 className="text-[#637381] uppercase font-bold text-xs pb-2">
											Numer telefonu
										</h3>
										<p className="text-[#19191B]">{data.user.mobile_phone}</p>
									</div>
								</div>
							</div>
							<div className="mt-4">
								<div className="flex items-center ">
									<img alt="user contact data icon" src={secondIcon} />
									<p className="font-semibold text-[17px] pl-3">
										Dane kontaktowe LTCA
									</p>
								</div>
								<div className="pl-[41px] pt-4">
									<div>
										<div className="pb-4">
											<h3 className="text-[#637381] uppercase font-bold text-xs pb-2">
												Email
											</h3>
											<p className="text-[#19191B]">kontakt@akademialtca.pl</p>
										</div>
									</div>
									<div>
										<div className="pb-4">
											<h3 className="text-[#637381] uppercase font-bold text-xs pb-2">
												Numer telefonu
											</h3>
											<p className="text-[#19191B]">+48 575 692 694</p>
										</div>
									</div>
								</div>
							</div>
							<Button
								className=" w-full border-[1px] border-slate-200 bg-[#282F41] text-white h-10 my-6"
								variant="ghost"
								onClick={logout}
							>
								Wyloguj
							</Button>
						</div>
					)}
					{state.switcher === "COURSES" && (
						<>
							{import.meta.env.VITE_DOWNLOAD_VIDEO_FEATURE_FLAG && (
								<Link to="/offline-videos">
									<div className="bg-white rounded-[8px] my-6 py-4 px-6 flex flex-nowrap justify-between items-center">
										<p className="text-sm w-3/4">
											Zobacz materiały pobrane na urządzenie do oglądania
											offline
										</p>
										<ArrowIcon className="rotate-180" />
									</div>
								</Link>
							)}
							<div>
								{data.resources.map((response) => {
									return (
										<>
											<h1 className="mt-5 mb-2 px-5 font-medium text-sm">
												{response.name}
											</h1>
											{response.media.map((element) => (
												<TrainingFile key={element.id} file={element} />
											))}
										</>
									);
								})}
							</div>
						</>
					)}
					{state.switcher === "CERTIFICATES" && (
						<div className="mt-6">
							{data.certificates.map((element) => {
								return (
									<div
										key={element.name}
										className="mb-[15px] bg-white rounded-[8px] px-2 py-4"
									>
										<div className="flex mb-[13px]">
											<img
												alt="resource image"
												className="max-h-[68px]"
												src={certificateIcon}
											/>
											<p className="font-medium ml-[10px]">{element.name}</p>
										</div>
										<div className="flex items-end justify-end">
											{/* <p className="text-[#637381] text-sm mr-[15px]">
												{el.endDate && `Data ukończenia ${el.endDate}`}
												{el.publicationDate &&
													`Data publikacji ${el.publicationDate}`}
											</p> */}
											{certificateLoader === element.name && (
												<LoaderSpinner className="mr-3" size={6} />
											)}
											<Button
												className=" border-[1px] border-[#919EAB3D]  h-[30px] mr-[10px] px-2 py-1"
												variant="ghost"
												onClick={async () => {
													await downloadCertificate(element);
												}}
											>
												Pobierz
											</Button>
											{/* {!el.endDate && (
												<Button
													className=" border-[1px] border-[#919EAB3D]  h-[30px] mr-[10px] px-2 py-1"
													variant="ghost"
												>
													Udostępnij
												</Button>
											)} */}
										</div>
									</div>
								);
							})}
						</div>
					)}
				</>
			)}
		</main>
	);
};
